<div fullPageModal>
  <h1 class="text-white">Signing you out</h1>
  <p class="text-white">Please wait</p>
</div>
